var _defs, _path, _line, _line2, _line3, _line4, _line5, _line6, _polygon, _line7, _circle, _line8, _line9, _line10, _line11, _line12, _line13, _polygon2, _line14, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferAcc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0077bf;}.cls-2{fill:none;stroke:#0077bf;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TransferAcc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.5,2A44.5,44.5,0,1,1,2,46.5,44.55,44.55,0,0,1,46.5,2m0-2A46.5,46.5,0,1,0,93,46.5,46.5,46.5,0,0,0,46.5,0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.96,
    y1: 47.03,
    x2: 26.96,
    y2: 32.61
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.77,
    y1: 32.61,
    x2: 31.77,
    y2: 47.03
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.55,
    y1: 47.03,
    x2: 18.55,
    y2: 32.61
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.36,
    y1: 32.61,
    x2: 23.36,
    y2: 47.03
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.37,
    y1: 47.03,
    x2: 35.37,
    y2: 32.61
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.18,
    y1: 32.61,
    x2: 40.18,
    y2: 47.03
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.36 21.8 16.15 29 16.15 32.61 42.58 32.61 42.58 29 29.36 21.8"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.15,
    y1: 47.03,
    x2: 42.58,
    y2: 47.03
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 29.37,
    cy: 27.8,
    r: 1.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.16,
    y1: 70.43,
    x2: 63.16,
    y2: 56.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 67.96,
    y1: 56.02,
    x2: 67.96,
    y2: 70.43
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.74,
    y1: 70.43,
    x2: 54.74,
    y2: 56.02
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.55,
    y1: 56.02,
    x2: 59.55,
    y2: 70.43
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.57,
    y1: 70.43,
    x2: 71.57,
    y2: 56.02
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 76.37,
    y1: 56.02,
    x2: 76.37,
    y2: 70.43
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.56 45.2 52.34 52.41 52.34 56.02 78.78 56.02 78.78 52.41 65.56 45.2"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 52.34,
    y1: 70.43,
    x2: 78.78,
    y2: 70.43
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 65.56,
    cy: 51.21,
    r: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46,66.81V61.53l-2.64,2.64A7.47,7.47,0,0,1,32.76,53.61l1.76-1.76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.5,28.55l1.76-1.76A7.47,7.47,0,0,1,59.83,37.36L57.19,40h5.28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferAcc);
export default __webpack_public_path__ + "static/media/TransferAcc.b7f76a747a3115b4093b0e83befff67e.svg";
export { ForwardRef as ReactComponent };